import {t} from "@lingui/core/macro";

export default function getFeedbackEditTip(
    feedbackCode?: string | null,
    feedbackType?: string | null,
    feedbackLetter?: string | null,
): string {
    if (feedbackCode === null) {
        return "";
    }

    const translatedFeedbackType = toFriendlyType(feedbackType || "");

    if (feedbackCode === "TOO_BRIEF") {
        return t`Your ${translatedFeedbackType} is too brief. Try writing a more specific ${translatedFeedbackType}.`;
    }

    if (feedbackCode === "BAD_CAPITALS") {
        return t`Try using standard capitalization to improve your ${translatedFeedbackType}'s quality.`;
    }

    if (feedbackCode === "TOO_MANY_REPEATS") {
        return t`Try to avoid repeating the "${feedbackLetter}" character so many times.`;
    }

    if (feedbackCode === "TIP_OR_THANKS") {
        return t`Are you trying to post a tip or thanks? Check out the Tips & Thanks section above.`;
    }
    if (feedbackCode === "RATE_LIMIT") {
        return t`Too many posts of this type in a short amount of time`;
    }
    return "";
}

// Convert GraphQL enum type to friendly type, when necessary.
// `QUESTION` -> `question`
// `SUGGESTED_CLARIFICATION` -> `suggested clarification`
const toFriendlyType = (type: string): string => {
    const friendlyType = type.replaceAll("_", " ").toLocaleLowerCase();

    if (friendlyType === "question") {
        return t`question`;
    }
    if (friendlyType === "answer") {
        return t`answer`;
    }
    if (friendlyType === "comment") {
        return t`comment`;
    }

    return friendlyType;
};
